import { render, staticRenderFns } from "./ButtonInputFields.vue?vue&type=template&id=2abd56ac"
import script from "./ButtonInputFields.vue?vue&type=script&lang=js"
export * from "./ButtonInputFields.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports